import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../ReduxToolkit/Hooks';
import { Image } from '../../AbstractElements';
import { handleResponsiveToggle, setToggleSidebar } from '../../ReduxToolkit/Reducers/LayoutSlice';
import { dynamicImage } from '../../Utils';
import SvgIcon from '../../Utils/CommonComponents/CommonIcons/CommonSvgIcons';

export default function LogoWrapper() {
  const dispatch = useAppDispatch();
  const { toggleSidebar } = useAppSelector((state) => state.layout)
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer)

  return (
    <>
      <div className="logo-wrapper">
        <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="img-fluid" src={dynamicImage("logo/logo_light.png")} alt="logo" />
        </Link>
        <div className="back-btn" onClick={() => dispatch(handleResponsiveToggle())}>
          <i className="fa fa-angle-left"></i>
        </div>
        <div className="toggle-sidebar">
          <SvgIcon className={`${sidebarIconType}-icon sidebar-toggle status_toggle middle`} iconId={`${sidebarIconType === "fill" ? "fill-toggle-icon" : "toggle-icon"}`} onClick={() => dispatch(setToggleSidebar(!toggleSidebar))} />
        </div>
      </div>
      <div className="logo-icon-wrapper">
        <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
          <Image className="img-fluid" src={dynamicImage("logo/logo-icon.png")} alt="logo" />
        </Link>
      </div>
    </>
  );
}